<template>
  <div class="add-card-wrap payway-item">
    <div
      @click="addCardActive"
      class="payway-row j-add-payway-item"
      :class="{ active: active_payway === 'addCard' }"
    >
      <div class="left">
        <div class="payment-radio"></div>
        <div class="payment-icon" :class="payType"></div>
        <div class="payment-name">{{ letter.addCard }}</div>
      </div>
    </div>
    <div class="payway-detail" v-show="active_payway === 'addCard'">
      <template v-if="!isWPOrAliPay">
        <!-- WorldPay不显示具体信息 -->
        <template v-if="!isCKO">
          <div class="detail-row card-number">
            <div class="detail-label">{{ letter.cardNum }}</div>
            <input
              class="card-input input-item"
              type="text"
              :placeholder="letter.cardNum"
              v-model="form.cardNumber"
              v-if="!isCKO"
            />
            <div class="error-tips" v-if="errorTips['card-number']">
              {{ letter.checkCard }}
            </div>
            <div class="error-tips" v-if="errorTips['unexpected-card']">
              {{ letter.checkCard }}
            </div>
          </div>
          <div class="detail-row expire-and-code">
            <div class="expire-item">
              <div class="detail-label">{{ letter.expireTime }}</div>
              <input
                class="expire-input short-input input-item"
                placeholder="MM/YY"
                v-model="form.expiryDate"
                v-if="!isCKO"
                type="text"
              />
              <div class="error-tips" v-if="errorTips['expiry-date']">
                {{ letter.checkExpiryDate }}
              </div>
            </div>
            <div class="code-item">
              <div class="detail-label">{{ letter.CVV }}</div>
              <input
                class="code-input short-input input-item"
                v-if="!isCKO"
                v-model="form.cvv"
                placeholder="CVV"
                type="text"
              />
              <div class="error-tips" v-if="errorTips['cvv']">
                {{ letter.checkCVV }}
              </div>
            </div>
          </div>
          <div class="detail-row select-row">
            <div
              class="select-text"
              :class="{ active: save_payway }"
              @click.stop="toggleSavePayway"
            >
              {{ letter.saveToNext }}
            </div>
          </div>
        </template>
        <div id="checkout-flow-container" v-if="isCKO"></div>
      </template>
      <div class="error-tips center" v-if="errorTips['pay']">
        {{ letter.checkAllCardMsg }}
      </div>
      <div
        class="pay-btn j-add-card-pay-btn"
        id="pay-button"
        @click="submitCard"
        :class="{ loading: showLoading }"
        v-if="!isCKO"
      >
        <span class="lock-icon"></span>
        <span class="pay-text"
          >{{ letter.neddPay }} {{ getMoneyWithUnit }}</span
        >
        <div class="spiral" v-if="showLoading">
          <div class="spiral-item"></div>
        </div>
      </div>
    </div>
    <PopupWindow
      v-if="showErrorPopup"
      type="tips"
      :languages="letter"
      :content="errorMessage"
      textAlign="center"
      @onConfirm="handleErrorPopupClose"
      @onCancel="handleErrorPopupClose"
    ></PopupWindow>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import {
  TOGGLE_SAVE_PAYWAY,
  SET_ACTIVE_PAYWAY,
  PAYMENT_REQUEST_ACTION
} from '@store/officialTopupNew/cash';
import { clickButton } from '@plugins/biPoint/_configWebstoreV35';
import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';
import checkoutFlowMixin from '@mixins/officialTopupNew/checkoutFlow';

export default {
  mixins: [checkoutFlowMixin],
  data() {
    return {
      logos: {
        'card-number': {
          src: 'card',
          alt: 'card number logo'
        },
        'expiry-date': {
          src: 'exp-date',
          alt: 'expiry date logo'
        },
        cvv: {
          src: 'cvv',
          alt: 'cvv logo'
        }
      },
      errorTips: {
        'card-number': false,
        'expiry-date': false,
        'unexpected-card': false,
        cvv: false,
        pay: false
      },
      showLoading: false,
      form: {
        cardNumber: '',
        expiryDate: '',
        cvv: ''
      }
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      active_payway: state => state.cash.active_payway,
      save_payway: state => state.cash.save_payway,
      order_id: state => state.cash.order_id,
      user_pay_infos: state => state.cash.user_pay_infos,
      f_pay_type: state => state.cash.f_pay_type,
      payment_session: state => state.cash.payment_session,
      public_key: state => state.cash.public_key,
      config_key: state => state.cash.config_key,
      lang: state => state.lang,
      payType: state => state.cash.pay_type
    }),
    ...mapGetters(['isCKO', 'isWPOrAliPay', 'getMoneyWithUnit', 'isSandBox'])
  },
  methods: {
    toggleSavePayway() {
      clickButton({
        btnName: 'save_credit_card'
      });
      this.$store.commit(TOGGLE_SAVE_PAYWAY);
    },
    addCardActive() {
      if (this.active_payway !== 'addCard') {
        pushTrackEvent({
          eventName: 'select_credit',
          eventType: 'new_credit_card'
        });
      }
      this.$store.commit(SET_ACTIVE_PAYWAY, 'addCard');
    },
    clearTips() {
      const inputArr = ['card-number', 'expiry-date', 'cvv', 'pay'];
      inputArr.forEach(item => (this.errorTips[item] = false));
    },
    checkForm() {
      //  WP无需校验直接可提交
      if (this.isWPOrAliPay) {
        return true;
      }
      // 如果CKO，但是为非限制卡号
      if (this.errorTips['unexpected-card']) {
        return false;
      }
      // 如果不是CKO和WP，则利用正则校验卡信息
      if (!this.isCKO && !this.isWPOrAliPay) {
        const cardNumberReg = /^\d{13,19}$/;
        const expiryDateReg = /^\d{2}\/\d{2}$/;
        const cvvReg = /^\d{3,4}$/;
        if (!cardNumberReg.test(this.form.cardNumber)) {
          this.errorTips['card-number'] = true;
          return false;
        }
        if (!expiryDateReg.test(this.form.expiryDate)) {
          this.errorTips['expiry-date'] = true;
          return false;
        }
        if (!cvvReg.test(this.form.cvv)) {
          this.errorTips['cvv'] = true;
          return false;
        }
      }
      this.clearTips();
      return true;
    },
    async submitCard() {
      // 是否Loading中
      if (this.showLoading) {
        return;
      }
      // 校验表单
      if (!this.checkForm()) {
        return;
      }
      const commitData = {
        source_type: 'token'
      };
      this.showLoading = true;
      clickButton({
        btnName: 'click-pay-btn'
      });
      await this.$store.dispatch(PAYMENT_REQUEST_ACTION, commitData);
    }
  },
  mounted() {
    if (this.isCKO) {
      this.initCheckoutFlow();
    }
  }
};
</script>
